import React, { useEffect } from 'react';

export const GitBookHider = ({ children }) => {
    useEffect(() => {
        var priorBtnDisplay = null;
        var priorPanelDisplay = null;

        function hide() {
            var btn = document.getElementById('gitbook-widget-button');
            var panel = document.getElementById('gitbook-widget-window');
            if (btn && priorBtnDisplay === null) {
                priorBtnDisplay = btn.style.display;
                btn.style.display = 'none';
            }
            if (panel && priorPanelDisplay === null) {
                priorPanelDisplay = panel.style.display;
                panel.style.display = 'none';
            }
            return !!btn && !!panel;
        }

        function restore() {
            var btn = document.getElementById('gitbook-widget-button');
            var panel = document.getElementById('gitbook-widget-window');
            if (btn && priorBtnDisplay !== null) btn.style.display = priorBtnDisplay;
            if (panel && priorPanelDisplay !== null) panel.style.display = priorPanelDisplay;
        }

        if (hide()) {
            return restore;
        }

        var observer = new MutationObserver(function() {
            if (hide()) {
                observer.disconnect();
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });

        return function() {
            observer.disconnect();
            restore();
        };
    }, []);

    return <>{children}</>;
};
